/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements */
import { useKeystoneSession } from '../../auth/use-keystone-session';
import { AccessoriesItemData, AccessoryData } from '@rta/rta-blueprint-library';
import { useEffect, useState } from 'react';

import { NavType } from '@state';
import { getProducts } from '@external';

// Singleton state outside the component
let accessoryItemDataCache: AccessoriesItemData | null = null;
let loadPromise: Promise<AccessoriesItemData> | null = null;

export const useLoadAccessoryData = (): AccessoriesItemData | null => {
	const { getToken, status } = useKeystoneSession();
	const isAuthenticated = status === 'ready';

	const [accessoriesItemData, setComponentItemData] = useState<AccessoriesItemData | null>(accessoryItemDataCache);

	useEffect(() => {
		if (!isAuthenticated) return;

		if (accessoryItemDataCache) {
			return;
		}

		if (loadPromise) {
			loadPromise.then(setComponentItemData);
			return;
		}

		loadPromise = (async () => {
			try {
				const accessoriesData = await getProducts<Record<string, AccessoryData>>({
					fileName: 'accessories-item-data',
					getToken,
					setError: (error) => console.error('Error loading accessories:', error)
				});

				accessoryItemDataCache = AccessoriesItemData.getInstance({
					callback: () => (accessoriesData || {})
				});

				console.log('Loaded accessories:', accessoryItemDataCache, accessoriesData);
				return accessoryItemDataCache;
			} catch (error) {
				console.error('Failed to load accessories data:', error);
				accessoryItemDataCache = AccessoriesItemData.getInstance({
					callback: () => ({})
				});
				return accessoryItemDataCache;
			}
		})();

		loadPromise.then(setComponentItemData);
	}, [isAuthenticated]);

	return accessoriesItemData;
};
